<template>
  <v-container>
    <List />
  </v-container>
</template>
<script>
import List from "../../components/Home/History.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "HomeView",
  components: {
    List,
  },
  computed: {
    ...mapGetters({
      getItems: "calcHistory/GET_ITEMS",
    }),
    items: {
      get: function () {
        return this.getItems;
      },
    },
  },
  methods: {
    ...mapActions({
      commitTitle: "common/COMMIT_TITLE",
      startRequest: "requestState/START_REQUEST",
      finishRequest: "requestState/FINISH_REQUEST",
      getItemsFromApi: "calcHistory/GET_ITEMS_FROM_API",
    }),
  },
  async created() {
    this.commitTitle("Главная");

    this.startRequest("calcHistoryList");

    await this.getItemsFromApi({
      pageNumber: 1,
    });

    this.finishRequest({
      requestName: "calcHistoryList",
      success: this.items != null,
    });
  },
};
</script>